import { CommonModule } from '@angular/common';
import { Component, ElementRef, forwardRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { IconDeleteChipsComponent } from 'app/icon/components/icon-delete-chips/icon-delete-chips.component';
import { ToastService } from 'app/toast/services/toast.service';
import { MdbDatepickerModule } from 'mdb-angular-ui-kit/datepicker';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';

@Component({
  standalone:true,
  imports:[CommonModule, FormsModule, ReactiveFormsModule, MdbFormsModule, MdbDatepickerModule, IconDeleteChipsComponent],
  selector: 'app-datepicker-chips',
  templateUrl: './datepicker-chips.component.html',
  styleUrls: ['./datepicker-chips.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatepickerChipsComponent),
    multi: true,
  }]
})
export class DatepickerChipsComponent implements OnInit {
  @ViewChild('datepickerChips') datepickerChips: ElementRef;
  list: string[] = []; 

  constructor(   
     private toastService: ToastService,
     private store: Store) {
   }


  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};
  ngOnInit(): void {
  }

  dropOption(index: any) { 
    if(this.list.length == 1){
      this.toastService.show('danger', 'You cannot remove last choosed date');
      return;
    }
    this.list.splice(index, 1);  
    this.onChangeCallback(this.list);
  }  


  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }

   writeValue(list: string[]) {
    this.list = list;
  }

  onDateChange(){
    this.onChooseDate(this.datepickerChips.nativeElement.value)
    this.datepickerChips.nativeElement.value = ''
    this.onChangeCallback(this.list);
  }

  onChooseDate(value: string){
    this.list.push(value.trim());
  }
}
